<template>
  <modal class="modal mt4" name="subscription-modal" transition="pop-out" :width="modalWidth" height="auto"  :adaptive="true" @before-open="beforeOpen">
    <div class="flex flex-column items-center mb3">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" />
        </a>
      </div>
      <div class="flex justify-center fl w-30 pb2">
        <img class="h-100 w-100" src="../../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <div v-show="loading">
        <clip-loader :loading="loading" :color="color" :size="size" class="mv2"></clip-loader>
      </div>
      <div class="w-70 hide-s">
        <subscription-info ></subscription-info>
      </div>
      <p class="tc silver mb0">{{ $t("users.subscription.valueTitle") }}</p>
      <p class="tc silver f1 fw2 ma0">
        <span v-if="showARG" class="f3">AR$</span>
        <span v-if="showUSD" class="f3">U$D</span>
        <span v-if="showARG">{{ pricing[0].currency_override.ARS }}</span>
        <span v-if="showUSD">{{ pricing[0].amount }}</span>
      </p>
      <div>
        <p>{{ $t("users.subscription.voucherCodeMsg") }}</p>
        <input type="text" v-model="voucherCode" maxlength="55" class="w-100">
      </div>
      <div>
        <p>{{ $t("users.subscription.referredCodeMsg") }}</p>
        <input type="text" v-model="refCodeInp" maxlength="55" class="w-100">
      </div>
      <button class="w-40-ns w-90 block mv2 pointer btn dim b f5 fw4" @click="openPayment">{{ $t("users.subscription.title") }}</button>
    </div>
  </modal>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import SubscriptionInfo from './SubscriptionInfo.vue'
  import { mapGetters, mapActions } from 'vuex'

  const MODAL_WIDTH = 600

  export default {
    name: 'subscription-modal',
    components: {
      ClipLoader,
      FontAwesomeIcon,
      SubscriptionInfo
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        voucherCode: null,
        showUSD: false,
        showARG: false,
        refCodeInp: null,
        canRefer: false
      }
    },
    computed: {
      ...mapGetters('user', [
        'error',
        'loading',
        'isLoggedIn',
        'user',
        'subsReferredCode'
      ]),
      ...mapGetters('pricing', [
        'pricing'
      ]),
      ...mapGetters('translator', [
        'language'
      ])
    },
    watch: {
      subsReferredCode: function (newSubsReferredCode, oldSubsReferredCode) {
        if (this.subsReferredCode && this.subsReferredCode !== 'false') {
          this.refCodeInp = this.subsReferredCode
        }
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
    },
    methods: {
      ...mapActions('user', [
        'getSubscriptionLinks',
        'checkVoucher'
      ]),
      closeModal () {
        this.$modal.hide('subscription-modal')
        this.voucherCode = null
        this.refCodeInp = null
      },
      beforeOpen (event) {
        this.showCurrency()
        if (this.subsReferredCode && this.subsReferredCode !== 'false') {
          this.refCodeInp = this.subsReferredCode
        } else {
          this.refCodeInp = ''
        }
      },
      openPayment () {
        this.checkVoucher(this.voucherCode).then((voucher) => {
          if (voucher && !voucher.hasOwnProperty('id')) {
            this.closeModal()
            return this.$toasted.show(this.$i18n.t(voucher), {type: 'error'})
          }
          if (this.isLoggedIn) {
            if (!this.isSubscribed) {
              this.$modal.show('payment-modal',
                {
                  paymentUrl: '/payment/subscribe/',
                  voucher: voucher,
                  refCode: this.refCodeInp
                }
              )
              this.closeModal()
            } else {
              this.$toasted.show('Ya estas suscrito!', {type: 'info'})
            }
          } else {
            this.closeModal()
            this.$modal.show('login-modal')
          }
        })
      },
      showCurrency () {
        if (this.language === 'es') {
          if (this.user.country === 'AR' || this.user.country === 'argentina' || this.user.country === 'Argentina' || this.user.country === 'ARG') {
            this.showUSD = false
            this.showARG = true
          }
          if (this.user.country !== 'AR' && this.user.country !== 'argentina' && this.user.country !== 'Argentina' && this.user.country !== 'ARG') {
            this.showUSD = true
            this.showARG = false
          }
        }
        if (this.language === 'en') {
          this.showUSD = true
          this.showARG = false
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }
  @media screen and (max-height: 630px) {
    .hide-m{
      width: 100vw;    /*  video width / height  */
      height: calc(100vw * (550 / 500));   /*  video height / width  */
    
    }
  }

  .pop-out-enter-active,
  .pop-out-leave-active {
    transition: all 0.5s;
  }
  .pop-out-enter,
  .pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/subscription/SubscriptionModal.vue